import { SITE } from '../../lib/site';
import { container, h2Section } from '../../lib/ui';
import { AppLink } from '../AppLink';
import { Icon } from '../Icon';

type Props = { title?: string; text?: string };

/** Closing "Ready to Translate Your Spatial Ambition?" banner on the services pages. */
export function ConsultationBanner({
  title = 'Ready to Translate Your Spatial Ambition?',
  text = 'Connect directly with our Principal Architect. We conduct comprehensive site audits and private concept reviews across Tamil Nadu, Bangalore, and Kerala.',
}: Props) {
  return (
    <section className="w-full py-space-xl md:py-20 bg-surface-cream relative">
      <div className={container}>
        <div className="reveal bg-surface-ivory rounded-2xl p-space-lg md:p-space-xl shadow-xl flex flex-col lg:flex-row items-start lg:items-center justify-between gap-space-lg">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 text-secondary font-label-sm text-label-sm uppercase tracking-widest mb-space-xs">
              <span className="w-2 h-2 rounded-full bg-emerald-vivid animate-pulse" />
              Accepting New Architectural Engagements
            </div>
            <h2 className={`${h2Section} mb-space-xs`}>{title}</h2>
            <p className="font-body-md text-body-md text-on-surface-variant">{text}</p>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-space-sm w-full lg:w-auto shrink-0">
            <AppLink
              href="/contact"
              className="w-full sm:w-auto px-6 py-4 rounded bg-primary text-gold-light hover:bg-primary-container font-label-lg text-label-lg uppercase tracking-wider text-center shadow-lg transition-all duration-300"
            >
              Book In-Studio Consultation
            </AppLink>
            <a
              href={`tel:${SITE.phoneE164}`}
              className="w-full sm:w-auto px-6 py-4 rounded bg-surface-container text-primary hover:bg-surface-container-high font-label-lg text-label-lg uppercase tracking-wider text-center shadow-sm transition-colors flex items-center justify-center gap-2 whitespace-nowrap"
            >
              <Icon name="call" size={16} />
              <span>{SITE.phoneDisplay}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
